import {useInjection} from "inversify-react";
import {useCallback, useEffect, useState} from "react";
import ApiService from "../../services/apiService";
import {ProductApi, TagApi, TagDto} from "../../api";
import TagsList from "./tagList";
import TagModalFormAddContainer from "./tagModalForm/tagModalFormContainer";
import Title from "antd/es/typography/Title";
import {useParams} from "react-router-dom";
import ExistingTagsModalForm from "./tagModalForm/existingTagsModalForm";
import {all} from "axios";

export default function TagsListContainer() {
    const apiService = useInjection(ApiService);
    const [allTags, setAllTags] = useState<TagDto[] | null>(null);
    const [productTags, setProductTags] = useState<TagDto[] | null>();
    const [isAddFormVisible, setAddFormVisible] = useState(false);
    const [isAddExistingFormVisible, setAddExistingFormVisible] = useState(false);
    const [tagModalFormContainerTitle, setTagModalFormContainerTitle] = useState<string>();
    const [idTagToEdit, setIdTagToEdit] = useState<number | null>(null);
    const [isLoading, setIsLoading] = useState<boolean>();
    let {productId} = useParams();

    const onExistingSubmit = async (values: any) => {
        await apiService.getApi(ProductApi).apiProductTagsPut({productId: +productId!, tagsIds: values.tagsIds});
        setAddExistingFormVisible(false)
        await refreshTagsList();
    }

    const refreshTagsList = useCallback(async () => {
        setIsLoading(true);
        try {
            const tags = await apiService.getApi(TagApi).apiTagGet();
            setAllTags(tags.data.filter(t => !t.productsIds?.includes(+productId!)));
            setProductTags(tags.data.filter(t => t.productsIds?.includes(+productId!)))
        } catch (e: any) {
            console.log(e.response.data);
        } finally {
            setIsLoading(false);
        }
    }, [apiService]);

    const onAddClicked = () => {
        setTagModalFormContainerTitle("Dodaj nowy tag");
        setIdTagToEdit(null);
        setAddFormVisible(true);
    }

    const onEditClicked = (id: number) => {
        setTagModalFormContainerTitle(`Edytuj tag o id: ${id}`);

        setIsLoading(true);
        setIdTagToEdit(id);
        setAddFormVisible(true);
    }

    const onDeleteClicked = async (id: number) => {
        const response = await apiService.getApi(TagApi).apiTagIdDelete(id)

        if (response.request.status !== 200) {
            console.log("Error occured while deleting data");
        } else {
            refreshTagsList();
        }
    }

    const onDeleteFromProductClicked = async (tag: TagDto) => {
        tag.productsIds = tag.productsIds?.filter(id => id !== +productId!)
        await apiService.getApi(TagApi).apiTagIdPut(tag.id!, tag)
        await refreshTagsList();
    }

    const onFinish = async (shouldRefresh: boolean) => {

        setAddFormVisible(false);

        if (shouldRefresh) {
            refreshTagsList();
        } else {
            setIsLoading(false);
        }
    }

    useEffect(() => {
        refreshTagsList();
    }, [refreshTagsList]);

    return <>
        <Title>Tagi:</Title>
        <TagsList
            onAddExistingClicked={() => setAddExistingFormVisible(true)}
            onDeleteFromProductClicked={onDeleteFromProductClicked}
            allTags={allTags || null}
            data={productTags || null}
            onAddClicked={onAddClicked}
            onEditClicked={onEditClicked}
            onDeleteClicked={onDeleteClicked}
            isLoading={isLoading}
        />
        <TagModalFormAddContainer
            onFinish={onFinish}
            id={idTagToEdit}
            addFormVisibility={isAddFormVisible}
            title={tagModalFormContainerTitle || ""}
        />
        <ExistingTagsModalForm onSubmit={onExistingSubmit} isModalVisible={isAddExistingFormVisible} setModalVisibility={setAddExistingFormVisible} modalTitle={"Dodaj istniejące tagi"}
                               saveButtonTitle={"Zapisz"} cancelButtonTitle={"Anuluj"} allTags={allTags}/>
    </>
}
